import React from 'react';
import { CTAButton } from './CTAButton';
export function PurchaseSection() {
  return <section id="compra" className="py-5 px-4 bg-black text-white text-center" data-id="element-110">
      <div className="max-w-4xl mx-auto" data-id="element-111">
        <h2 className="text-[20px] font-black mb-2 text-[#F9327E]" data-id="element-112">
          Accede ahora al Megapack Inclusión Educativa
        </h2>

        <p className="text-xl md:text-2xl font-medium mb-3 max-w-2xl mx-auto" data-id="element-113">
          Tener todo el material adaptado, organizado y listo para imprimir
          puede ahorrarte muchas horas de trabajo y ayudarte a que más
          estudiantes participen activamente.
        </p>

        <div className="flex justify-center mb-3" data-id="element-114">
          <img src="https://cdn.magicpatterns.com/uploads/6StH4fvB71N27f4GFRSpio/mockup_pincipal.png" alt="Megapack Inclusión Educativa completo con todos los bonus" className="w-full max-w-[280px] h-auto object-contain drop-shadow-2xl" data-id="element-115" />
        </div>

        <div className="mb-3" data-id="element-116">
          <p className="text-gray-400 text-lg uppercase tracking-widest font-bold mb-1" data-id="element-117">
            PRECIO ÚNICO
          </p>
          <p className="text-6xl md:text-7xl font-black text-white mb-2" data-id="element-118">
            USD 14.99
          </p>
        </div>

        <div className="bg-gray-900 p-5 md:p-8 rounded-3xl border-2 border-gray-800 shadow-2xl max-w-2xl mx-auto" data-id="element-119">
          <CTAButton href="https://pay.hotmart.com/D106353714J" className="w-full text-xl md:text-2xl py-6 mb-2 flex items-center justify-center gap-3" data-id="element-120">
            👉 QUIERO MI MEGAPACK AHORA
          </CTAButton>

          <p className="text-sm text-gray-400 mb-4" data-id="element-121">Paga con tu moneda local</p>

          <a href="https://drive.google.com/file/d/1l0lFp9o58awx-IzSZbGKQ1FApgOIUfVh/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-block text-lg md:text-xl font-bold text-yellow-400 hover:text-yellow-300 underline underline-offset-4 mb-2 transition-colors" data-id="element-122">
            📄 Ver muestra gratis
          </a>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm md:text-base font-bold text-gray-300 mt-6" data-id="element-123">
            <span className="flex items-center" data-id="element-124">
              <span className="text-green-500 mr-2" data-id="element-125">✔</span> para 1° a 6° grado
            </span>
            <span className="flex items-center" data-id="element-126">
              <span className="text-green-500 mr-2" data-id="element-127">✔</span> acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-128">
              <span className="text-green-500 mr-2" data-id="element-129">✔</span> descarga digital
            </span>
            <span className="flex items-center" data-id="element-130">
              <span className="text-green-500 mr-2" data-id="element-131">✔</span> material listo
              para imprimir
            </span>
          </div>
        </div>
      </div>
    </section>;
}